import useSelfie from "lib/hooks/useSelfie";
import { invariant } from "outvariant";

export default function useViewerCountry() {
  const viewer = useSelfie();

  invariant(viewer, "Viewer is not defined");
  invariant(viewer.country, "Viewer country is not defined");

  return ["BR", "PT"].includes(viewer.country) ? "BR" : "US";
}
